import { Stack, Text as ManText, Tooltip } from '@mantine/core';
import { LinearGradient } from '@visx/gradient';
import { Group } from '@visx/group';
import { Polygon } from '@visx/shape';
import { Text } from '@visx/text';
import React, { memo } from 'react';
import { NodeProps } from 'reactflow';

export const ParaRightNodeFlow = memo(({ id, data }: NodeProps) => {
    const gradId = `v-gradient-${id}`;

    const textWidth = Math.max(data.width - 80, data.label.length * 8);
    const numberOfLines = Math.ceil(textWidth / (data.width - 80));

    const getSvG = () => (
        <svg
            width={data.width}
            height={data.height}
            className={!data.disabled ? 'zoom' : undefined}
            onClick={!data.disabled ? data.onClick : undefined}
            style={!data.disabled ? { cursor: 'pointer' } : undefined}
        >
            <Group>
                <LinearGradient id={gradId} from={data.gradientStart} to={data.gradientEnd} />
                <Polygon
                    center={{ x: data.xCenter, y: 40 }}
                    sides={4}
                    size={55}
                    rotate={45}
                    fill={
                        data.disabled ?
                            'var(--mantine-color-read-only-input)'
                        :   data.backgroundColor ?? `url(#${gradId})`
                    }
                    style={{ transform: `skewX(-30deg) scaleX(${data.scale}) scaleY(${data.height / 80})` }}
                    textAnchor={'middle'}
                />
                <Text
                    x={data.width / 2}
                    y={
                        (data.height +
                            (-10 * numberOfLines + 20) -
                            Math.round((data.width - (numberOfLines < 2 ? 80 : 0)) / textWidth) * 22) /
                        2
                    }
                    width={Math.min(textWidth, data.width - 80)}
                    verticalAnchor={'start'}
                    textAnchor={'middle'}
                    style={{ fontFamily: 'Roboto' }}
                    fill={data.disabled ? 'white' : data.textColor ?? 'white'}
                >
                    {data.label}
                </Text>
            </Group>
        </svg>
    );

    if (data.tooltipDescription) {
        return (
            <Tooltip
                withArrow
                w={'auto'}
                label={
                    <Stack gap={'xs'}>
                        <ManText size={'xs'}>{data.tooltipDescription}</ManText>
                    </Stack>
                }
            >
                {getSvG()}
            </Tooltip>
        );
    }
    return getSvG();
});
